import React, { FC } from 'react';
import Price from 'components/Common/Price/Price';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { ProductItemPreviewProps } from 'store/product/types';
import NavigationTag from 'components/Common/NavigationTag/NavigationTag';
import PricingBadge, { PricingBadgeSize } from 'components/Common/Prices/PricingBadge/PricingBadge';
import calculateDiscountPercent from 'utils/price/calculateDiscountPercent';
import style from './ProductItemPreview.module.scss';

const ProductItemPreview: FC<ProductItemPreviewProps> = ({
  productId,
  categoryId,
  productName,
  productThumbnail,
  productUrl,
  showPrice,
  usePriceFromProps,
  theme,
  initialPrice,
  initialPriceFormatted,
  finalPrice,
  finalPriceFormatted,
  onClick,
}) => {
  const { t } = useTranslation();
  const hasDiscount = initialPrice !== finalPrice;

  const discountedPercent = finalPrice && initialPrice && calculateDiscountPercent(finalPrice, initialPrice);

  return (
    <div className={cn(style.container, style[`theme-${theme}`])} onClick={onClick}>
      {productUrl ? (
        <NavigationTag url={productUrl || ''} className={style.productItemPreview}>
          <div className={style.productImageWrapper}>
            <img src={productThumbnail} loading="lazy" className={style.productImage} alt="" />
          </div>
        </NavigationTag>
      ) : (
        <div className={style.productItemPreview}>
          <img src={productThumbnail} loading="lazy" className={style.productImage} alt="" />
        </div>
      )}
      <div className={style.productName}>{productName}</div>
      {showPrice && (
        <>
          {!usePriceFromProps && (
            <div className={style.price}>
              <Price prefix={t('txt_from')} categoryId={categoryId || 1} productId={productId || 1} />
            </div>
          )}
          {usePriceFromProps && (
            <div className={style.price}>
              {hasDiscount && (
                <div className={style.withDiscount}>
                  {discountedPercent && (
                    <div className={style.discount}>
                      <PricingBadge fontSize={PricingBadgeSize.sm} discount={discountedPercent} />
                    </div>
                  )}
                  <span className={style.crossed} dangerouslySetInnerHTML={{ __html: initialPriceFormatted || '' }} />
                  <span className={style.red} dangerouslySetInnerHTML={{ __html: finalPriceFormatted || '' }} />
                </div>
              )}
              {!hasDiscount && <span dangerouslySetInnerHTML={{ __html: initialPriceFormatted || '' }} />}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ProductItemPreview;
